import { getElementById } from "../util/Utils";
import { any } from "../util/Reductions";

const ToggleNames = [
  "DUMMY",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_EXPERIMENT",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_TRACKING",
  "HEUREKA_1913_MIGRATE_TO_OC_SHEET",
  "HEUREKA_1980_SHOE_SIZE_PERSONALIZATION",
  "HEUREKA_1991_RENDER_HIDDEN_SELECTED_FILTERS",
  "HEUREKA_2012_FIX_FIRST_LEVEL_FILTERS_STYLING_ON_RELOAD_ERROR",
  "HEUREKA_2047_NEXT_BEST_FACET",
  "HEUREKA_2047_NEXT_BEST_FACET_E3792",
  "HEUREKA_2047_ADJUST_TRACKING",
  "HEUREKA_2062_NBF_FOR_DESKTOP",
  "HEUREKA_2062_NBF_FOR_DESKTOP_E3676",
  "HEUREKA_2070_OTTO_CHIP_ON_MOBILE",
  "HEUREKA_2086_HIDE_RANGE_SELECT_BUTTON",
  "HEUREKA_2113_SORTING_SELECT_CHIP",
  "HEUREKA_2117_MOUNT_NBF_DIRECTLY_IN_REFINEMENT_BAR",
  "HEUREKA_2122_SHEET_MEHR_ANZEIGEN_WIRD_ALLE",
  "HEUREKA_2135_MOVE_ELEMENTS_TO_REFINEMENT_BAR",
  "HEUREKA_2167_MIGRATE_FILTER_BANNER_TO_SVELTE",
  "HEUREKA_2167_MIGRATE_DESKTOP_SORTING_TO_SVELTE",
  "HEUREKA_2178_FILTER_SECTION_IS_NOT_LOADED",
  "HEUREKA_2193_HIDE_FLOATING_FILTER_ABOVE_REFINEMENT_BAR",
  "HEUREKA_1975_OC_CHIP_MIGRATION",
  "HEUREKA_2275_FIX_SORTING_AFTER_FILTERING",
  "HEUREKA_2276_STATELESS_TRACKING_CHANGE",
  "HEUREKA_2276_STATELESS_TRACKING_SUBMIT",
  "HEUREKA_2288_LAZY_FILTER_LOADING",
] as const;

export type ToggleName = (typeof ToggleNames)[number];
export type ToggleStates = Record<ToggleName, boolean>;

let toggles: ToggleStates;

function asBoolean(value?: string): boolean {
  return "true" === value;
}

export function initToggles() {
  const data = getElementById("leafcutter_toggles")?.dataset;
  const state = data
    ? (toggleName: ToggleName) => asBoolean(data[toggleName] || data[toggleName.toLowerCase()])
    : () => false;
  toggles = ToggleNames.reduce((htmlToggles, toggleName) => {
    htmlToggles[toggleName] = state(toggleName);
    return htmlToggles;
  }, {} as Partial<ToggleStates>) as ToggleStates;
}

/**
 *
 */
export function updateToggle(toggle: ToggleName, state: boolean) {
  if (!toggles) {
    toggles = {} as ToggleStates;
  }
  toggles[toggle] = state;
}

export function isActive(toggle: ToggleName) {
  return toggles[toggle];
}

export function isNotActive(toggle: ToggleName) {
  return !isActive(toggle);
}

export function isAnyActive(...toggles: ToggleName[]) {
  return toggles.map(isActive).reduce(any, false);
}
